export function formatDetectionDomain(value: string): string {
  const normalized = value.toLocaleLowerCase().replace(/[_\s-]+/g, "");
  return normalized === "playlist" || normalized === "sharedplaylists" ? "SharedPlaylists" : value;
}
